import { assign } from 'lodash';
import { getValue } from '../utils/localStorage';

const development = {
  api: 'https://qa2.enphaseenergy.com',
  enlighten_url: 'https://qa2.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  solargraf_url: 'https://staging.solargraf.com',
  solargraf_api_url: 'https://api-staging.solargraf.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  drs_url: 'https://drs-api-stg.enphaseenergy.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  enlighten_api_url: 'https://qa2.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const test = {
  api: 'https://enlighten-qa4.enphaseenergy.com',
  enlighten_url: 'https://enlighten-qa4.enphaseenergy.com',
  ein_core_url: 'https://eincore-dev.enphaseenergy.com',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  digital_core_url: 'https://dc-dev.enphaseenergy.com',
  drs_url: 'https://drs-api-dev.enphaseenergy.com',
  drs_ui_url: 'https://drs-dev.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-qa4.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const qa2 = {
  api: 'https://qa2.enphaseenergy.com',
  enlighten_url: 'https://qa2.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  drs_url: 'https://drs-api-stg.enphaseenergy.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  enlighten_api_url: 'https://qa2.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const qa4 = {
  api: 'https://enlighten-dev.qa-enphaseenergy.com',
  enlighten_url: 'https://enlighten-dev.qa-enphaseenergy.com',
  ein_core_url: 'https://ein-core-api-dev.qa-enphaseenergy.com',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  digital_core_url: 'https://b2c-core-dev.qa-enphaseenergy.com',
  drs_url: 'https://drs-api-dev.qa-enphaseenergy.com',
  drs_ui_url: 'https://drs-ui-dev.qa-enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-dev.qa-enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const cotqa4 = {
  api: 'https://enlighten-cotqa4.enphaseenergy.com',
  enlighten_url: 'https://enlighten-cotqa4.enphaseenergy.com',
  ein_core_url: 'https://eincore-dev.enphaseenergy.com',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  digital_core_url: 'https://dc-dev.enphaseenergy.com',
  drs_url: 'https://drs-api-dev.enphaseenergy.com',
  drs_ui_url: 'https://drs-dev.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-cotqa4.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const preprod = {
  api: 'https://enlighten-preprod.enphaseenergy.com',
  enlighten_url: 'https://enlighten-preprod.enphaseenergy.com',
  digital_core_url: 'https://dc-preprod.enphaseenergy.com',
  ein_core_url: 'https://ein-core-preprod.enphaseenergy.com',
  solargraf_url: 'https://app.solargraf.com',
  solargraf_api_url: 'https://api.solargraf.com',
  drs_ui_url: 'https://drs-preprod.enphaseenergy.com',
  drs_url: 'https://drs-api-preprod.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-preprod.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const production = {
  api: 'https://enlighten.enphaseenergy.com',
  enlighten_url: 'https://enlighten.enphaseenergy.com',
  ein_core_url: 'https://ein-core.enphaseenergy.com',
  solargraf_url: 'https://app.solargraf.com',
  solargraf_api_url: 'https://api.solargraf.com',
  digital_core_url: 'https://dc.enphaseenergy.com',
  drs_url: 'https://drs-api.enphaseenergy.com',
  drs_ui_url: 'https://drs.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const dev = {
  api: 'https://enlighten-dev.enphaseenergy.com',
  enlighten_url: 'https://enlighten-dev.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  drs_url: 'https://drs-api-stg.enphaseenergy.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-dev.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const stg = {
  api: 'https://enlighten-stg.enphaseenergy.com',
  enlighten_url: 'https://enlighten-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  drs_url: 'https://drs-api-stg.enphaseenergy.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-stg.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const rel = {
  api: 'https://enlighten-rel.enphaseenergy.com',
  enlighten_url: 'https://enlighten-rel.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  drs_url: 'https://drs-api-stg.enphaseenergy.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-rel.enphaseenergy.com',
  enphase_ui_url: 'https://enphase.com',
};

const integration = {
  api: 'https://enlighten-intg.qa-enphaseenergy.com',
  enlighten_url: 'https://enlighten-intg.qa-enphaseenergy.com',
  ein_core_url: 'https://ein-core-api-intg.qa-enphaseenergy.com',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  digital_core_url: 'https://b2c-core-intg.qa-enphaseenergy.com',
  drs_url: 'https://drs-api-intg.qa-enphaseenergy.com',
  drs_ui_url: 'https://drs-ui-intg.qa-enphaseenergy.com',
  enlighten_api_url: 'https://enlighten-intg.qa-enphaseenergy.com',
 enphase_ui_url: 'https://enphase.com',
};

const DEFAULT = {};

const CONFIG = {
  development,
  production,
  preprod,
  test,
  qa2,
  qa4,
  cotqa4,
  dev,
  stg,
  rel,
  integration,
};

const getConfig = () => {
  var env = (typeof window !== 'undefined') ? window.build_environment : test;
  console.log('window.build_environment', window.build_environment);
  if (env) {
    CONFIG[env].api = '';
    CONFIG[env].enlighten_url = '';
  } else {
    let hostname;
    if (typeof window !== 'undefined') {
      hostname = window.location.hostname;
      if (
        hostname.search('enlighten.enphaseenergy') >= 0 ||
        hostname.search('permit.enphaseenergy') >= 0 ||
        hostname.search('drs.enphaseenergy') >= 0
      ) {
        env = 'production';
      } else if (
        hostname.search('enlighten-preprod.enphaseenergy') >= 0 ||
        hostname.search('drs-preprod.enphaseenergy') >= 0
      ) {
        env = 'preprod';
      } else if (
        hostname.search('permit-stg.enphaseenergy') >= 0 ||
        hostname.search('drs-stg.enphaseenergy') >= 0
      ) {
          if (getValue('referrer')?.includes('enlighten-rel')) {
            env = 'rel';
          } else {
            env = 'qa2';
          }
      } else if (
        hostname.search('permit-ui-intg.qa-enphaseenergy') >= 0 ||
        hostname.search('drs-ui-intg.qa-enphaseenergy') >= 0
      ) {
        env = 'integration';
      }
       else if (hostname.search('qa2.enphaseenergy') >= 0) {
        env = 'qa2';
      } else if (
        hostname.search('enlighten-dev') >= 0 ||
        hostname.search('permit-ui-dev.qa-enphaseenergy') >= 0 ||
        hostname.search('drs-ui-dev.qa-enphaseenergy') >= 0
      ) {
        env = 'qa4';
      } else if (hostname.search('enl(ighten)?-(cot)?qa4') >= 0) {
        env = 'cotqa4';
      } else if (hostname.search('enlighten-dev') >= 0) {
        env = 'dev';
      } else if (hostname.search('enlighten-stg') >= 0) {
        env = 'stg';
      } else if (hostname.search('enlighten-rel') >= 0) {
        env = 'rel';
      } else if (hostname.search('enlighten-intg') >= 0) {
        env = 'integration';
      } else if (
        window.location.port === '8001' ||
        window.location.port === '7000' ||
        window.location.port === '4200'
      ) {
        env = getValue('development_env') || 'development';
      } else {
        env = 'development';
      }
    }
  }
  const envConfig = CONFIG[env];
  console.log('Common UI App running environment is -> ', env);
  // envConfig = CONFIG[env];
  if (envConfig) {
    return assign({}, DEFAULT, envConfig);
  }
  throw new Error('Unknown environment : ' + env);
};

export default getConfig;
